var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCanceled = function SvgCanceled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    viewBox: "0 0 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B0BEC5",
    d: "M64 0C28.656 0 0 28.656 0 64s28.656 64 64 64 64-28.656 64-64S99.344 0 64 0m0 120C33.125 120 8 94.875 8 64S33.125 8 64 8s56 25.125 56 56-25.125 56-56 56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F44336",
    d: "m75.313 64 16.969-16.969c3.125-3.125 3.125-8.195 0-11.313-3.117-3.125-8.188-3.125-11.313 0L64 52.688 47.031 35.719c-3.125-3.125-8.195-3.125-11.313 0-3.125 3.117-3.125 8.188 0 11.313L52.688 64 35.719 80.969c-3.125 3.125-3.125 8.195 0 11.313 3.117 3.125 8.188 3.125 11.313 0L64 75.313l16.969 16.969c3.125 3.125 8.195 3.125 11.313 0 3.125-3.117 3.125-8.188 0-11.313z"
  })));
};
export default SvgCanceled;